import activitiesServiceGen from "./generated/activitiesServiceGen";

class activitiesService extends activitiesServiceGen {
}

export default activitiesService;